import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { CommonService } from '../services/common.service';
import { environment } from '../../environments/environment';
import { ApiConstants } from '../models/apiType.model';

export const AuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const commonService = inject(CommonService);
  const authService = inject(AuthService);
  const token = authService.getJWTToken();//authService.getToken();

  const loginUrl = `${environment.API_URL}/${ApiConstants.loginEndPoint}`;
  const originUrl = `${environment.API_URL}/${environment.ORIGIN_PATH}`;

  const authReq = token ? req.clone({
   setHeaders: {
     Authorization: `Bearer ${token}`
   }
  }) : req;

  // const authReq = req.url.includes(loginUrl) ? req : req.clone({
  //   setHeaders: {
  //     Authorization: `Bearer ${token}`
  //   }
  // });

  return next(authReq).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && !authReq.url.includes(originUrl)) {        
        //commonService.openSnackBar('Your session has expired. Please log in again.', '', 'error');
        //authService.logoutApp();
        console.log('Your session has expired. Please log in again.', '', 'error');
        commonService.openSessionExpiredModal();  
        return [];
      }      
      return throwError(() => error);
    })
  );


};
